// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"OH60vY"};